import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStaticmanComponent } from './simple-icons-staticman.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStaticmanComponent ],
    exports:      [ SimpleIconsStaticmanComponent ],
    bootstrap:    []
})
export class SimpleIconsStaticmanModule {}
